import { AxiosRequestConfig } from "axios";

export const postRecoverPasswordConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user/password-recover",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
